export enum PageOption {
    first, next, pre, last
}
